import { COLORS } from '../../../constant';
import { HStack, Box, Link } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { DotIcon, IconTheme } from './DotIcon';

type BaseMessageProps = {
  message: string;
  onClick: React.MouseEventHandler<HTMLAnchorElement>;
  theme?: IconTheme;
};

const BaseMessage = ({
  message,
  onClick,
  theme = 'default',
}: BaseMessageProps): ReactElement | null => {
  return (
    <HStack spacing="4px">
      <DotIcon theme={theme} />
      <Box as="span" color={COLORS.FINCH.BLACK} pr="1">
        {message}
      </Box>
      <Link
        onClick={onClick}
        color={COLORS.ORANGE}
        textDecoration="underline"
        _hover={{
          color: COLORS.FINCH.BLACK,
        }}
      >
        View Now
      </Link>
    </HStack>
  );
};

type MessageProps = {
  connectionCount: number;
  onClick: React.MouseEventHandler<HTMLAnchorElement>;
};

export const AttentionNeededMessage = ({
  connectionCount,
  onClick,
}: MessageProps): ReactElement | null => {
  if (!connectionCount) return null;
  let connectionCountMessage = `${connectionCount} connection needs attention`;
  if (connectionCount > 1) {
    connectionCountMessage = `${connectionCount} connections need attention`;
  }

  return (
    <BaseMessage
      message={connectionCountMessage}
      onClick={onClick}
      theme="warning"
    />
  );
};

export const SyncingFailuresMessage = ({
  connectionCount,
  onClick,
}: MessageProps): ReactElement | null => {
  if (!connectionCount) return null;
  let connectionCountMessage = `${connectionCount} Automated connection hasn’t synced in 2 or more days`;
  if (connectionCount > 1) {
    connectionCountMessage = `${connectionCount} Automated connections haven’t synced in 2 or more days`;
  }

  return (
    <BaseMessage
      message={connectionCountMessage}
      onClick={onClick}
      theme="default"
    />
  );
};
